import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { formatRelative, plural } from '../../../utils/format';
import { useActiveEvents } from '../hooks/useHomeLists';

const EventRow = ({ event }) => (
  <Link to={`/events/${event.id}`} className="home-event-mini">
    <div>
      <div className="home-event-title">{event.title || 'Untitled event'}</div>
      <div className="home-event-meta">
        {plural(Number(event.session_count || 0), 'session')} · {formatRelative(event.updated_at || event.created_at, '')}
      </div>
    </div>
    <ChevronRightIcon />
  </Link>
);

export default function ActiveEvents() {
  const [events, loading, error] = useActiveEvents();
  return (
    <aside className="home-sidebar" aria-label="Active events">
      <div className="home-section-head">
        <h2>Active events</h2>
        <Link to="/events">All <ArrowRightIcon /></Link>
      </div>
      <div className="home-events-list">
        {loading ? (
          <div className="home-event-mini"><div className="home-spinner" />Loading…</div>
        ) : error || events.length === 0 ? (
          <div className="home-event-mini"><div className="home-event-meta">{error || 'No ongoing events.'}</div></div>
        ) : events.map((event) => <EventRow key={event.id} event={event} />)}
      </div>
    </aside>
  );
}
